import React from 'react'

function App() {
	return (
		<>
			<meta charSet='UTF-8' />
			<title>Midtrans Node</title>
			<style dangerouslySetInnerHTML={{ __html: '' }} />
			<link
				rel='stylesheet'
				href='https://cdn.jsdelivr.net/gh/Microsoft/vscode/extensions/markdown-language-features/media/markdown.css'
			/>
			<link
				rel='stylesheet'
				href='https://cdn.jsdelivr.net/gh/Microsoft/vscode/extensions/markdown-language-features/media/highlight.css'
			/>
			<style
				dangerouslySetInnerHTML={{
					__html:
						"\n\t\t\tbody {\n\t\t\t\tfont-family: -apple-system, BlinkMacSystemFont, 'Segoe WPC', 'Segoe UI', system-ui, 'Ubuntu', 'Droid Sans', sans-serif;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tline-height: 1.5;\n\t\t\t}\n\t\t"
				}}
			/>
			<style
				dangerouslySetInnerHTML={{
					__html:
						'\n\t\t\t.task-list-item {\n\t\t\t\tlist-style-type: none;\n\t\t\t}\n\t\t\t.task-list-item-checkbox {\n\t\t\t\tmargin-left: -20px;\n\t\t\t\tvertical-align: middle;\n\t\t\t}\n\t\t'
				}}
			/>
			<h1 id='midtrans-node'>Midtrans Node</h1>
			<p>
				<a href='https://travis-ci.org/restuwahyu13/midtrans-node'>
					<img src='https://travis-ci.org/restuwahyu13/midtrans-node.svg?branch=main' alt='Build Status' />
				</a>
				<a href='https://coveralls.io/github/restuwahyu13/nodejs-midtrans-client?branch=main'>
					<img
						src='https://coveralls.io/repos/github/restuwahyu13/nodejs-midtrans-client/badge.svg?branch=main'
						alt='Coverage Status'
					/>
				</a>
				<img src='https://img.shields.io/node/v/midtrans-node-client?style=flat-square' alt='node-current' />
				<img src='https://img.shields.io/npm/dm/midtrans-node-client' alt='npm' />
				<img src='https://img.shields.io/bundlephobia/min/midtrans-node-client' alt='npm bundle size' />
				<img src='https://img.shields.io/bundlephobia/minzip/midtrans-node-client' alt='npm bundle size (version)' />
				<img
					src='https://img.shields.io/snyk/vulnerabilities/npm/midtrans-node-client?style=flat-square'
					alt='Snyk Vulnerabilities for npm package'
				/>
				<a href='https://github.com/restuwahyu13/midtrans-node/blob/main/CONTRIBUTING.html'>
					<img src='https://img.shields.io/badge/PRs-welcome-brightgreen.svg?style=flat-square' alt='PRs Welcome' />
				</a>
			</p>
			<ul>
				<li>
					<a href='#installation'>Installation</a>
				</li>
				<li>
					<a href='#api-documentation'>API Documentation</a>
					<ul>
						<li>
							<a href='#core-api-documentation'>Core API Documentation</a>
						</li>
						<li>
							<a href='#iris-api-documentation'>Iris API Documentation</a>
						</li>
						<li>
							<a href='#snap-api-documentation'>Snap API Documentation</a>
						</li>
					</ul>
				</li>
				<li>
					<a href='#api-reference'>API Reference</a>
					<ul>
						<li>
							<a href='#core-api-services'>Core API Services</a>
							<ul>
								<li>
									<a href='#charge-parameter-object---promise'>charge</a>
								</li>
								<li>
									<a href='#capture-parameter-object---promise'>capture</a>
								</li>
								<li>
									<a href='#cardregister-parameter-object---promise'>cardRegister</a>
								</li>
								<li>
									<a href='#cardtoken-parameter-object---promise'>cardToken</a>
								</li>
								<li>
									<a href='#cardpointinquiry-tokenid-string---promise'>cardPointInquiry</a>
								</li>
							</ul>
						</li>
						<li>
							<a href='#iris-api-services'>Iris API Services</a>
							<ul>
								<li>
									<a href='#ping-promise'>ping</a>
								</li>
								<li>
									<a href='#createbeneficiaries-parameter-object--promise'>createBeneficiaries</a>
								</li>
								<li>
									<a href='#updatebeneficiaries-aliasname-string-parameter-object--promise'>updateBeneficiaries</a>
								</li>
								<li>
									<a href='#getbeneficiaries-promise'>getBeneficiaries</a>
								</li>
								<li>
									<a href='#createpayouts-parameter-object--promise'>createPayouts</a>
								</li>
								<li>
									<a href='#approvepayouts-parameter-object--promise'>approvePayouts</a>
								</li>
								<li>
									<a href='#rejectpayouts-parameter-object--promise'>rejectPayouts</a>
								</li>
								<li>
									<a href='#getpayoutdetails-referenceno-string--promise'>getPayoutDetails</a>
								</li>
								<li>
									<a href='#gettransactionhistory-parameter-string-promise'>getTransactionHistory</a>
								</li>
								<li>
									<a href='#gettopupchannels-promise'>getTopupChannels</a>
								</li>
								<li>
									<a href='#getbalance-promise'>getBalance</a>
								</li>
								<li>
									<a href='#getfacilitatorbankaccounts-promise'>getFacilitatorBankAccounts</a>
								</li>
								<li>
									<a href='#getfacilitatorbalance-bankaccountid-string--promise'>getFacilitatorBalance</a>
								</li>
								<li>
									<a href='#getbeneficiarybanks-promise'>getBeneficiaryBanks</a>
								</li>
								<li>
									<a href='#validatebankaccount-parameter-object--promise'>validateBankAccount</a>
								</li>
							</ul>
						</li>
						<li>
							<a href='#snap-api-services'>Snap API Services</a>
							<ul>
								<li>
									<a href='#createtransaction-parameter-object--promise'>createTransaction</a>
								</li>
								<li>
									<a href='#createtransactiontoken-parameter-object--promise'>createTransactionToken</a>
								</li>
								<li>
									<a href='#createtransactionredirecturl-parameter-object--promise'>createTransactionRedirectUrl</a>
								</li>
							</ul>
						</li>
						<li>
							<a href='#transaction-api-services'>Transaction API Services</a>
							<ul>
								<li>
									<a href='#status-transactionid-string--promise'>status</a>
								</li>
								<li>
									<a href='#statusb2b-transactionid-string--promise'>statusb2b</a>
								</li>
								<li>
									<a href='#approve-transactionid-string--promise'>approve</a>
								</li>
								<li>
									<a href='#deny-transactionid-string--promise'>deny</a>
								</li>
								<li>
									<a href='#cancel-transactionid-string--promise'>cancel</a>
								</li>
								<li>
									<a href='#expire-transactionid-string--promise'>expire</a>
								</li>
								<li>
									<a href='#refund-transactionid-string-parameter-object-promise'>refund</a>
								</li>
								<li>
									<a href='#refunddirect-transactionid-string-parameter-object-promise'>refundDirect</a>
								</li>
								<li>
									<a href='#notification-notification-object--promise'>notification</a>
								</li>
							</ul>
						</li>
					</ul>
				</li>
				<li>
					<a href='#custome-usage'>Custome Usage</a>
					<ul>
						<li>
							<a href='#charge-parameter-object---promise'>charge</a>
						</li>
						<li>
							<a href='#createtransaction-parameter-object--promise'>createTransaction</a>
						</li>
					</ul>
				</li>
				<li>
					<a href='#custome-reference'>Custome Reference</a>
				</li>
				<li>
					<a href='#testing'>Testing</a>
				</li>
				<li>
					<a href='#bugs'>Bugs</a>
				</li>
				<li>
					<a href='#contributing'>Contributing</a>
				</li>
				<li>
					<a href='#license'>License</a>
				</li>
			</ul>
			<h2 id='installation'><b>Installation</b></h2>
			<pre>
				<code className='language-bash'>
					<div>npm install midtrans-node-client -S or yarn add midtrans-node-client -S{'\n'}</div>
				</code>
			</pre>
			<h2 id='api-documentation'><b>API Documentation</b></h2>
			<ul>
				<li>
					<h4 id='core-api-documentation' style={{fontWeight: 500}}>Core API Documentation</h4>
					<p>
						follow this link for more related information
						<a href='https://api-docs.midtrans.com/'>Core Midtrans API Reference</a> official
					</p>
				</li>
				<li>
					<h4 id='iris-api-documentation' style={{fontWeight: 500}}>Iris API Documentation</h4>
					<p>
						follow this link for more related information
						<a href='https://iris-docs.midtrans.com/'>Iris Midtrans API Reference</a> official
					</p>
				</li>
				<li>
					<h4 id='snap-api-documentation' style={{fontWeight: 500}}>Snap API Documentation</h4>
					<p>
						follow this link for more related information
						<a href='https://snap-docs.midtrans.com/'>Snap Midtrans API Reference</a> official
					</p>
				</li>
			</ul>
			<h2 id='api-reference'><b>API Reference</b></h2>
			<h3 id='core-api-services'>Core API Services</h3>
			<ul>
				<li>
					<h4 id='charge-parameter-object---promise'>charge( parameter: object ) : Promise</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>charge</td>
								<td>
									<em>POST</em>
								</td>
								<td>Create transaction with various available payment methods and features</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} <span className='hljs-attr'>v4</span>: uuidv4 {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'uuid'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> core = <span className='hljs-keyword'>new</span>{' '}
								MidtransClient.CoreApi({'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}core.charge({'{'}
								{'\n'}
								{'      '}
								<span className='hljs-attr'>payment_type</span>: <span className='hljs-string'>'bank_transfer'</span>,{'\n'}
								{'      '}
								<span className='hljs-attr'>bank_transfer</span>: {'{'} <span className='hljs-attr'>bank</span>:{' '}
								<span className='hljs-string'>'bca'</span> {'}'},{'\n'}
								{'      '}
								<span className='hljs-attr'>transaction_details</span>: {'{'}
								{'\n'}
								{'        '}
								<span className='hljs-attr'>order_id</span>: uuidv4(),{'\n'}
								{'        '}
								<span className='hljs-attr'>gross_amount</span>: <span className='hljs-number'>100000</span>
								{'\n'}
								{'      '}
								{'}'},{'\n'}
								{'      '}
								<span className='hljs-attr'>item_details</span>: [{'\n'}
								{'        '}
								{'{'}
								{'\n'}
								{'         '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'         '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'ayam bakar sambal balado'</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>2</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>25000</span>
								{'\n'}
								{'        '}
								{'}'},{'\n'}
								{'        '}
								{'{'}
								{'\n'}
								{'         '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'         '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'sop iga bakar daging lunak'</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>1</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>30000</span>
								{'\n'}
								{'        '}
								{'}'},{'\n'}
								{'        '}
								{'{'}
								{'\n'}
								{'         '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'         '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'just alpuckat'</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>2</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>10000</span>
								{'\n'}
								{'        '}
								{'}'}
								{'\n'}
								{'      '}],{'\n'}
								{'      '}
								<span className='hljs-attr'>customer_details</span>: {'{'}
								{'\n'}
								{'      '}
								{'\t'}
								<span className='hljs-attr'>first_name</span>: <span className='hljs-string'>'restu wahyu'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>last_name</span>: <span className='hljs-string'>' saputra'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>email</span>: <span className='hljs-string'>'restuwahyu13@zetmail.com'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>phone</span>: <span className='hljs-string'>'087820154350'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>billing_address</span>:{'  '}
								{'{'}
								{'\n'}
								{'          '}
								<span className='hljs-attr'>address</span>: <span className='hljs-string'>'jl.sibuta gua hantu no.120'</span>,
								{'\n'}
								{'          '}
								<span className='hljs-attr'>city</span>: <span className='hljs-string'>'Depok'</span>,{'\n'}
								{'          '}
								<span className='hljs-attr'>postal_code</span>: <span className='hljs-string'>'16436'</span>
								{'\n'}
								{'        '}
								{'}'}
								{'\n'}
								{'      '}
								{'}'}
								{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} v4 <span className='hljs-keyword'>as</span> uuidv4 {'}'}{' '}
								<span className='hljs-keyword'>from</span> <span className='hljs-string'>'uuid'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> core = <span className='hljs-keyword'>new</span>{' '}
								MidtransClient.CoreApi({'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}core.charge({'{'}
								{'\n'}
								{'      '}
								<span className='hljs-attr'>payment_type</span>: <span className='hljs-string'>'bank_transfer'</span>,{'\n'}
								{'      '}
								<span className='hljs-attr'>bank_transfer</span>: {'{'} <span className='hljs-attr'>bank</span>:{' '}
								<span className='hljs-string'>'bca'</span> {'}'},{'\n'}
								{'      '}
								<span className='hljs-attr'>transaction_details</span>: {'{'}
								{'\n'}
								{'        '}
								<span className='hljs-attr'>order_id</span>: uuidv4(),{'\n'}
								{'        '}
								<span className='hljs-attr'>gross_amount</span>: <span className='hljs-number'>100000</span>
								{'\n'}
								{'      '}
								{'}'},{'\n'}
								{'      '}
								<span className='hljs-attr'>item_details</span>: [{'\n'}
								{'        '}
								{'{'}
								{'\n'}
								{'         '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'         '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'ayam bakar sambal balado'</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>2</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>25000</span>
								{'\n'}
								{'        '}
								{'}'},{'\n'}
								{'        '}
								{'{'}
								{'\n'}
								{'         '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'         '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'sop iga bakar daging lunak'</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>1</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>30000</span>
								{'\n'}
								{'        '}
								{'}'},{'\n'}
								{'        '}
								{'{'}
								{'\n'}
								{'         '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'         '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'just alpuckat'</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>2</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>20000</span>
								{'\n'}
								{'        '}
								{'}'}
								{'\n'}
								{'      '}],{'\n'}
								{'      '}
								<span className='hljs-attr'>customer_details</span>: {'{'}
								{'\n'}
								{'      '}
								{'\t'}
								<span className='hljs-attr'>first_name</span>: <span className='hljs-string'>'restu wahyu'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>last_name</span>: <span className='hljs-string'>' saputra'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>email</span>: <span className='hljs-string'>'restuwahyu13@zetmail.com'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>phone</span>: <span className='hljs-string'>'087820154350'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>billing_address</span>:{'  '}
								{'{'}
								{'\n'}
								{'          '}
								<span className='hljs-attr'>address</span>: <span className='hljs-string'>'jl.sibuta gua hantu no.120'</span>,
								{'\n'}
								{'          '}
								<span className='hljs-attr'>city</span>: <span className='hljs-string'>'Depok'</span>,{'\n'}
								{'          '}
								<span className='hljs-attr'>postal_code</span>: <span className='hljs-string'>'16436'</span>
								{'\n'}
								{'        '}
								{'}'}
								{'\n'}
								{'      '}
								{'}'}
								{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
			</ul>
			<ul>
				<li>
					<h4 id='capture-parameter-object---promise'>capture( parameter: object ) : Promise</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>capture</td>
								<td>
									<em>POST</em>
								</td>
								<td>Capture an authorized transaction for card payment</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-1'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> core = <span className='hljs-keyword'>new</span>{' '}
								MidtransClient.CoreApi({'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}core.capture({'{'}
								{'\n'}
								{'      '}
								<span className='hljs-attr'>transaction_id</span>:{' '}
								<span className='hljs-string'>"be4f3e44-d6ee-4355-8c64-c1d1dc7f4590"</span>,{'\n'}
								{'      '}
								<span className='hljs-attr'>gross_amount</span>: <span className='hljs-number'>100000</span>
								{'\n'}
								{'    '}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-1'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> core = <span className='hljs-keyword'>new</span>{' '}
								MidtransClient.CoreApi({'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}core.capture({'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>transaction_id</span>:{' '}
								<span className='hljs-string'>"be4f3e44-d6ee-4355-8c64-c1d1dc7f4590"</span>,{'\n'}
								{'     '}
								<span className='hljs-attr'>gross_amount</span>: <span className='hljs-number'>100000</span>
								{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
				<li>
					<h4 id='cardregister-parameter-object---promise'>cardRegister( parameter: object ) : Promise</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>cardRegister</td>
								<td>
									<em>GET</em>
								</td>
								<td>Register card information (card number and expiry) to be used for two clicks and one click</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-2'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> core = <span className='hljs-keyword'>new</span>{' '}
								MidtransClient.CoreApi({'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}core.cardRegister({'{'}
								{'\n'}
								{'  	 '}
								<span className='hljs-attr'>card_number</span>: <span className='hljs-string'>'5421813858532415'</span>,{'\n'}
								{'  	 '}
								<span className='hljs-attr'>card_exp_month</span>: <span className='hljs-string'>'10'</span>,{'\n'}
								{'  	 '}
								<span className='hljs-attr'>card_exp_year</span>: <span className='hljs-string'>'2024'</span>,{'\n'}
								{'  	 '}
								<span className='hljs-attr'>card_cvv</span>: <span className='hljs-string'>'426'</span>,{'\n'}
								{'  	 '}
								<span className='hljs-attr'>client_key</span>: core.apiConfig.get().clientKey{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-2'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> core = <span className='hljs-keyword'>new</span>{' '}
								MidtransClient.CoreApi({'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}core.cardRegister({'{'}
								{'\n'}
								{'  	 '}
								<span className='hljs-attr'>card_number</span>: <span className='hljs-string'>'5421813858532415'</span>,{'\n'}
								{'  	 '}
								<span className='hljs-attr'>card_exp_month</span>: <span className='hljs-string'>'10'</span>,{'\n'}
								{'  	 '}
								<span className='hljs-attr'>card_exp_year</span>: <span className='hljs-string'>'2024'</span>,{'\n'}
								{'  	 '}
								<span className='hljs-attr'>card_cvv</span>: <span className='hljs-string'>'426'</span>,{'\n'}
								{'  	 '}
								<span className='hljs-attr'>client_key</span>: core.apiConfig.get().clientKey{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
				<li>
					<h4 id='cardtoken-parameter-object---promise'>cardToken( parameter: object ) : Promise</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>cardToken</td>
								<td>
									<em>GET</em>
								</td>
								<td>Tokenize Credit Card information before being charged</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-3'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> core = <span className='hljs-keyword'>new</span>{' '}
								MidtransClient.CoreApi({'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}core.cardToken({'{'}
								{'\n'}
								{'  	 '}
								<span className='hljs-attr'>card_number</span>: <span className='hljs-string'>'5421813858532415'</span>,{'\n'}
								{'  	 '}
								<span className='hljs-attr'>card_exp_month</span>: <span className='hljs-string'>'10'</span>,{'\n'}
								{'  	 '}
								<span className='hljs-attr'>card_exp_year</span>: <span className='hljs-string'>'2024'</span>,{'\n'}
								{'  	 '}
								<span className='hljs-attr'>card_cvv</span>: <span className='hljs-string'>'426'</span>,{'\n'}
								{'  	 '}
								<span className='hljs-attr'>client_key</span>: core.apiConfig.get().clientKey{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-3'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> core = <span className='hljs-keyword'>new</span>{' '}
								MidtransClient.CoreApi({'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}core.cardToken({'{'}
								{'\n'}
								{'  	 '}
								<span className='hljs-attr'>card_number</span>: <span className='hljs-string'>'5421813858532415'</span>,{'\n'}
								{'  	 '}
								<span className='hljs-attr'>card_exp_month</span>: <span className='hljs-string'>'10'</span>,{'\n'}
								{'  	 '}
								<span className='hljs-attr'>card_exp_year</span>: <span className='hljs-string'>'2024'</span>,{'\n'}
								{'  	 '}
								<span className='hljs-attr'>card_cvv</span>: <span className='hljs-string'>'426'</span>,{'\n'}
								{'  	 '}
								<span className='hljs-attr'>client_key</span>: core.apiConfig.get().clientKey{'\n'}
								{'    '}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
				<li>
					<h4 id='cardpointinquiry-tokenid-string---promise'>cardPointInquiry( tokenId: string ) : Promise</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>cardPointInquiry</td>
								<td>
									<em>GET</em>
								</td>
								<td>Get the point balance of the card in denomination amount</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-4'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> core = <span className='hljs-keyword'>new</span>{' '}
								MidtransClient.CoreApi({'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}core.cardPointInquiry(
								<span className='hljs-string'>"526422-4659-80f25158-71dd-4a87-aad2-3c37689e6bfd"</span>){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-4'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> core = <span className='hljs-keyword'>new</span>{' '}
								MidtransClient.CoreApi({'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}core.cardPointInquiry(
								<span className='hljs-string'>"526422-4659-80f25158-71dd-4a87-aad2-3c37689e6bfd"</span>){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
			</ul>
			<h3 id='iris-api-services'>Iris API Services</h3>
			<ul>
				<li>
					<h4 id='ping-promise'>ping(): Promise</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>ping</td>
								<td>
									<em>GET</em>
								</td>
								<td>Returns pong message for monitoring purpose</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-5'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> iris = <span className='hljs-keyword'>new</span> MidtransClient.Iris(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}iris.ping(){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-5'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> iris = <span className='hljs-keyword'>new</span> MidtransClient.Iris(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}iris.ping(){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
				<li>
					<h4 id='createbeneficiaries-parameter-object--promise'>createBeneficiaries( parameter: object ): Promise</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>createBeneficiaries</td>
								<td>
									<em>POST</em>
								</td>
								<td>create a new beneficiary information for quick access on the payout page in Iris Portal.</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-6'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> iris = <span className='hljs-keyword'>new</span> MidtransClient.Iris(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}iris.createBeneficiaries({'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'Restu Wahyu Saputra'</span>,{'\n'}
								{'     '}
								<span className='hljs-attr'>account</span>: <span className='hljs-string'>'5432198760'</span>,{'\n'}
								{'     '}
								<span className='hljs-attr'>bank</span>: <span className='hljs-string'>'bca'</span>,{'\n'}
								{'     '}
								<span className='hljs-attr'>alias_name</span>: <span className='hljs-string'>'restu'</span>,{'\n'}
								{'     '}
								<span className='hljs-attr'>email</span>: <span className='hljs-string'>'restuwahyu13@zetmail.com'</span>
								{'	\n   '}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-6'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> iris = <span className='hljs-keyword'>new</span> MidtransClient.Iris(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}iris.createBeneficiaries({'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'Restu Wahyu Saputra'</span>,{'\n'}
								{'     '}
								<span className='hljs-attr'>account</span>: <span className='hljs-string'>'5432198760'</span>,{'\n'}
								{'     '}
								<span className='hljs-attr'>bank</span>: <span className='hljs-string'>'bca'</span>,{'\n'}
								{'     '}
								<span className='hljs-attr'>alias_name</span>: <span className='hljs-string'>'restu'</span>,{'\n'}
								{'     '}
								<span className='hljs-attr'>email</span>: <span className='hljs-string'>'restuwahyu13@zetmail.com'</span>
								{'	\n    '}
								{'}'}){'\n'}
								{'    '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'    '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
				<li>
					<h4 id='updatebeneficiaries-aliasname-string-parameter-object--promise'>
						updateBeneficiaries( aliasName: string, parameter: object ): Promise
					</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>updateBeneficiaries</td>
								<td>
									<em>PATCH</em>
								</td>
								<td>Update an existing beneficiary identified by its alias_name</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-7'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> iris = <span className='hljs-keyword'>new</span> MidtransClient.Iris(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}iris.updateBeneficiaries(<span className='hljs-string'>'restu'</span>,{'{'}
								{'\n'}
								{'   	 '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'Restu Wahyu Saputra'</span>,{'\n'}
								{'   	 '}
								<span className='hljs-attr'>account</span>: <span className='hljs-string'>'5432198760'</span>,{'\n'}
								{'   	 '}
								<span className='hljs-attr'>bank</span>: <span className='hljs-string'>'bca'</span>,{'\n'}
								{'   	 '}
								<span className='hljs-attr'>alias_name</span>: <span className='hljs-string'>'restu'</span>,{'\n'}
								{'   	 '}
								<span className='hljs-attr'>email</span>: <span className='hljs-string'>'restuwahyu13@zetmail.com'</span>
								{'\n   '}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-7'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> iris = <span className='hljs-keyword'>new</span> MidtransClient.Iris(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}iris.updateBeneficiaries(<span className='hljs-string'>'restu'</span>,{'{'}
								{'\n'}
								{'   	 '}
								 <span className='hljs-attr'>name</span>: <span className='hljs-string'>'Restu Wahyu Saputra'</span>,{'\n'}
								{'   	 '}							
								 <span className='hljs-attr'>account</span>: <span className='hljs-string'>'5432198760'</span>,{'\n'}
								{'   	 '}
								 <span className='hljs-attr'>bank</span>: <span className='hljs-string'>'bca'</span>,{'\n'}
								{'   	 '}
								 <span className='hljs-attr'>alias_name</span>: <span className='hljs-string'>'restu'</span>,{'\n'}
								{'   	 '}
								 <span className='hljs-attr'>email</span>: <span className='hljs-string'>'restuwahyu13@zetmail.com'</span>
								{'\n    '}
								{'}'}){'\n'}
								{'    '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'    '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
				<li>
					<h4 id='getbeneficiaries-promise'>getBeneficiaries(): Promise</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>getBeneficiaries</td>
								<td>
									<em>GET</em>
								</td>
								<td>Fetch list of all beneficiaries saved in Iris Portal</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-8'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> iris = <span className='hljs-keyword'>new</span> MidtransClient.Iris(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}iris.getBeneficiaries(){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-8'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> iris = <span className='hljs-keyword'>new</span> MidtransClient.Iris(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}iris.getBeneficiaries(){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
				<li>
					<h4 id='createpayouts-parameter-object--promise'>createPayouts( parameter: object ): Promise</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>createPayouts</td>
								<td>
									<em>POST</em>
								</td>
								<td>Creator to create a payout. It can be used for single payout and also multiple payouts.</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-9'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> iris = <span className='hljs-keyword'>new</span> MidtransClient.Iris(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}iris.createPayouts({'{'}
								{'\n'}
								{'    '}
								<span className='hljs-attr'>payouts</span>: [{'\n'}
								{'       '}
								{'{'}
								{'\n'}
								{'         '}
								<span className='hljs-attr'>beneficiary_name</span>: <span className='hljs-string'>'Restu Wahyu Saputra'</span>,
								{'\n'}
								{'         '}
								<span className='hljs-attr'>beneficiary_account</span>: <span className='hljs-string'>'5432198760'</span>,{'\n'}
								{'         '}
								<span className='hljs-attr'>beneficiary_bank</span>: <span className='hljs-string'>'bca'</span>,{'\n'}
								{'         '}
								<span className='hljs-attr'>beneficiary_email</span>:{' '}
								<span className='hljs-string'>'restuwahyu13@zetmail.com'</span>,{'\n'}
								{'         '}
								<span className='hljs-attr'>amount</span>: <span className='hljs-string'>'100000'</span>,{'\n'}
								{'         '}
								<span className='hljs-attr'>notes</span>: <span className='hljs-string'>'Payout 31 January 2021'</span>
								{'\n'}
								{'       '}
								{'}'}
								{'\n'}
								{'     '}]{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-9'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> iris = <span className='hljs-keyword'>new</span> MidtransClient.Iris(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}iris.createPayouts({'{'}
								{'\n'}
								{'    '}
								<span className='hljs-attr'>payouts</span>: [{'\n'}
								{'       '}
								{'{'}
								{'\n'}
								{'         '}
								<span className='hljs-attr'>beneficiary_name</span>: <span className='hljs-string'>'Restu Wahyu Saputra'</span>,
								{'\n'}
								{'         '}
								<span className='hljs-attr'>beneficiary_account</span>: <span className='hljs-string'>'5432198760'</span>,{'\n'}
								{'         '}
								<span className='hljs-attr'>beneficiary_bank</span>: <span className='hljs-string'>'bca'</span>,{'\n'}
								{'         '}
								<span className='hljs-attr'>beneficiary_email</span>:{' '}
								<span className='hljs-string'>'restuwahyu13@zetmail.com'</span>,{'\n'}
								{'         '}
								<span className='hljs-attr'>amount</span>: <span className='hljs-string'>'100000'</span>,{'\n'}
								{'         '}
								<span className='hljs-attr'>notes</span>: <span className='hljs-string'>'Payout 31 January 2021'</span>
								{'\n'}
								{'       '}
								{'}'}
								{'\n'}
								{'     '}]{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
				<li>
					<h4 id='approvepayouts-parameter-object--promise'>approvePayouts( parameter: object ): Promise</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>approvePayouts</td>
								<td>
									<em>POST</em>
								</td>
								<td>Apporver to approve multiple payout request.</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-10'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> iris = <span className='hljs-keyword'>new</span> MidtransClient.Iris(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}iris.approvePayouts({'{'}
								{'\n'}
								{'\t'}
								{'\t'}
								{'\t'}
								<span className='hljs-attr'>reference_nos</span>: [<span className='hljs-string'>'20543502291'</span>],{'\n'}
								{'\t'}
								{'\t'}
								{'\t'}
								<span className='hljs-attr'>otp</span>: <span className='hljs-string'>'335163'</span>
								{'\n'}
								{'\t'}
								{'\t'}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-10'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> iris = <span className='hljs-keyword'>new</span> MidtransClient.Iris(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}iris.approvePayouts({'{'}
								{'\n'}
								{'\t'}
								{'\t'}
								{'\t'}
								<span className='hljs-attr'>reference_nos</span>: [<span className='hljs-string'>'20543502291'</span>],{'\n'}
								{'\t'}
								{'\t'}
								{'\t'}
								<span className='hljs-attr'>otp</span>: <span className='hljs-string'>'335163'</span>
								{'\n'}
								{'\t'}
								{'\t'}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
				<li>
					<h4 id='rejectpayouts-parameter-object--promise'>rejectPayouts( parameter: object ): Promise</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>rejectPayouts</td>
								<td>
									<em>POST</em>
								</td>
								<td>Apporver to reject multiple payout request.</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-11'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> iris = <span className='hljs-keyword'>new</span> MidtransClient.Iris(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}iris.rejectPayouts({'{'}
								{'\n'}
								{'  	 '}
								<span className='hljs-attr'>reference_nos</span>: [<span className='hljs-string'>'eyad5swd9b026c5kmr'</span>],
								{'\n'}
								{'  	 '}
								<span className='hljs-attr'>reject_reason</span>: <span className='hljs-string'>'Reason to reject payouts'</span>
								{'\n '}
								{'  '}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-11'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> iris = <span className='hljs-keyword'>new</span> MidtransClient.Iris(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}iris.rejectPayouts({'{'}
								{'\n'}
								{'  	 '}
								<span className='hljs-attr'>reference_nos</span>: [<span className='hljs-string'>'eyad5swd9b026c5kmr'</span>],
								{'\n'}
								{'  	 '}
								<span className='hljs-attr'>reject_reason</span>: <span className='hljs-string'>'Reason to reject payouts'</span>
								{'\n '}
								{'  '}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
				<li>
					<h4 id='getpayoutdetails-referenceno-string--promise'>getPayoutDetails( referenceNo: string ): Promise</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>getPayoutDetails</td>
								<td>
									<em>GET</em>
								</td>
								<td>Get details of a single payout</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-12'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> iris = <span className='hljs-keyword'>new</span> MidtransClient.Iris(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}iris.rejectPayouts({'{'}
								{'\n'}
								{'  	 '}
								<span className='hljs-attr'>reference_nos</span>: [<span className='hljs-string'>'eyad5swd9b026c5kmr'</span>],
								{'\n'}
								{'  	 '}
								<span className='hljs-attr'>reject_reason</span>: <span className='hljs-string'>'Reason to reject payouts'</span>
								{'\n '}
								{'  '}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-12'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> iris = <span className='hljs-keyword'>new</span> MidtransClient.Iris(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}iris.rejectPayouts({'{'}
								{'\n'}
								{'  	 '}
								<span className='hljs-attr'>reference_nos</span>: [<span className='hljs-string'>'eyad5swd9b026c5kmr'</span>],
								{'\n'}
								{'  	 '}
								<span className='hljs-attr'>reject_reason</span>: <span className='hljs-string'>'Reason to reject payouts'</span>
								{'\n '}
								{'  '}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
				<li>
					<h4 id='gettransactionhistory-parameter-string-promise'>getTransactionHistory( parameter: string): Promise</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>getTransactionHistory</td>
								<td>
									<em>GET</em>
								</td>
								<td>List all transactions history for a month.</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-13'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> iris = <span className='hljs-keyword'>new</span> MidtransClient.Iris(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}iris.getTransactionHistory({'{'} <span className='hljs-attr'>from_date</span>:{' '}
								<span className='hljs-string'>"2020-11-01"</span>, <span className='hljs-attr'>to_date</span>:{' '}
								<span className='hljs-string'>"2020-12-28"</span> {'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-13'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> iris = <span className='hljs-keyword'>new</span> MidtransClient.Iris(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}iris.getTransactionHistory({'{'} <span className='hljs-attr'>from_date</span>:{' '}
								<span className='hljs-string'>"2020-11-01"</span>, <span className='hljs-attr'>to_date</span>:{' '}
								<span className='hljs-string'>"2020-12-28"</span> {'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
				<li>
					<h4 id='gettopupchannels-promise'>getTopupChannels(): Promise</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>getTopupChannels</td>
								<td>
									<em>GET</em>
								</td>
								<td>Provide top up information channel for Aggregator Partner</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-14'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> iris = <span className='hljs-keyword'>new</span> MidtransClient.Iris(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}iris.getTopupChannels(){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-14'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> iris = <span className='hljs-keyword'>new</span> MidtransClient.Iris(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}iris.getTopupChannels(){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
				<li>
					<h4 id='getbalance-promise'>getBalance(): Promise</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>getBalance</td>
								<td>
									<em>GET</em>
								</td>
								<td>get current balance</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-15'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> iris = <span className='hljs-keyword'>new</span> MidtransClient.Iris(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}iris.getBalance(){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-15'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> iris = <span className='hljs-keyword'>new</span> MidtransClient.Iris(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}iris.getBalance(){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
				<li>
					<h4 id='getfacilitatorbankaccounts-promise'>getFacilitatorBankAccounts(): Promise</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>getFacilitatorBankAccounts</td>
								<td>
									<em>GET</em>
								</td>
								<td>Show list of registered bank accounts for facilitator partner</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-16'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> iris = <span className='hljs-keyword'>new</span> MidtransClient.Iris(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}iris.getFacilitatorBankAccounts(){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-16'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> iris = <span className='hljs-keyword'>new</span> MidtransClient.Iris(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}iris.getFacilitatorBankAccounts(){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
				<li>
					<h4 id='getfacilitatorbalance-bankaccountid-string--promise'>
						getFacilitatorBalance( bankAccountId: string ): Promise
					</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>getFacilitatorBalance</td>
								<td>
									<em>GET</em>
								</td>
								<td>Get current balance information of your registered bank account.</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-17'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> iris = <span className='hljs-keyword'>new</span> MidtransClient.Iris(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}iris.getFacilitatorBalance(<span className='hljs-string'>'mandiri38fd1f0e'</span>){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-17'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> iris = <span className='hljs-keyword'>new</span> MidtransClient.Iris(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}iris.getFacilitatorBalance(<span className='hljs-string'>'mandiri38fd1f0e'</span>){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
				<li>
					<h4 id='getbeneficiarybanks-promise'>getBeneficiaryBanks(): Promise</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>getBeneficiaryBanks</td>
								<td>
									<em>GET</em>
								</td>
								<td>Show list of supported banks in IRIS.</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-18'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> iris = <span className='hljs-keyword'>new</span> MidtransClient.Iris(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}iris.getBeneficiaryBanks(){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-18'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> iris = <span className='hljs-keyword'>new</span> MidtransClient.Iris(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}iris.getBeneficiaryBanks(){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
				<li>
					<h4 id='validatebankaccount-parameter-object--promise'>validateBankAccount( parameter: object ): Promise</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>validateBankAccount</td>
								<td>
									<em>GET</em>
								</td>
								<td>Check if an account is valid, if valid return account information.</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-19'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> iris = <span className='hljs-keyword'>new</span> MidtransClient.Iris(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}iris.validateBankAccount({'{'} <span className='hljs-attr'>bank</span>:{' '}
								<span className='hljs-string'>'danamon'</span>, <span className='hljs-attr'>account</span>:{' '}
								<span className='hljs-string'>'000001137298'</span> ){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-19'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> iris = <span className='hljs-keyword'>new</span> MidtransClient.Iris(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}iris.validateBankAccount({'{'} <span className='hljs-attr'>bank</span>:{' '}
								<span className='hljs-string'>'danamon'</span>, <span className='hljs-attr'>account</span>:{' '}
								<span className='hljs-string'>'000001137298'</span> ){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
			</ul>
			<h3 id='snap-api-services'>Snap API Services</h3>
			<ul>
				<li>
					<h4 id='createtransaction-parameter-object--promise'>createTransaction( parameter: object ): Promise</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>createTransaction</td>
								<td>
									<em>POST</em>
								</td>
								<td>create transaction payment using snap integaration payment method</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-20'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} <span className='hljs-attr'>v4</span>: uuidv4 {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'uuid'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> snap = <span className='hljs-keyword'>new</span> MidtransClient.Snap(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}snap.createTransaction({'{'}
								{'\n'}
								{'      '}
								<span className='hljs-attr'>payment_type</span>: <span className='hljs-string'>'bank_transfer'</span>,{'\n'}
								{'      '}
								<span className='hljs-attr'>bank_transfer</span>: {'{'} <span className='hljs-attr'>bank</span>:{' '}
								<span className='hljs-string'>'bca'</span> {'}'},{'\n'}
								{'      '}
								<span className='hljs-attr'>transaction_details</span>: {'{'}
								{'\n'}
								{'        '}
								<span className='hljs-attr'>order_id</span>: uuidv4(),{'\n'}
								{'        '}
								<span className='hljs-attr'>gross_amount</span>: <span className='hljs-number'>100000</span>
								{'\n'}
								{'      '}
								{'}'},{'\n'}
								{'      '}
								<span className='hljs-attr'>item_details</span>: [{'\n'}
								{'        '}
								{'{'}
								{'\n'}
								{'         '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'         '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'ayam bakar sambal balado'</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>2</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>25000</span>
								{'\n'}
								{'        '}
								{'}'},{'\n'}
								{'        '}
								{'{'}
								{'\n'}
								{'         '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'         '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'sop iga bakar daging lunak'</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>1</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>30000</span>
								{'\n'}
								{'        '}
								{'}'},{'\n'}
								{'        '}
								{'{'}
								{'\n'}
								{'         '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'         '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'just alpuckat'</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>2</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>10000</span>
								{'\n'}
								{'        '}
								{'}'}
								{'\n'}
								{'      '}],{'\n'}
								{'        '}
								<span className='hljs-attr'>customer_details</span>: {'{'}
								{'\n'}
								{'        '}
								<span className='hljs-attr'>first_name</span>: <span className='hljs-string'>'restu wahyu'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>last_name</span>: <span className='hljs-string'>' saputra'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>email</span>: <span className='hljs-string'>'restuwahyu13@zetmail.com'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>phone</span>: <span className='hljs-string'>'087820154350'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>billing_address</span>:{'  '}
								{'{'}
								{'\n'}
								{'          '}
								<span className='hljs-attr'>address</span>: <span className='hljs-string'>'jl.sibuta gua hantu no.120'</span>,
								{'\n'}
								{'          '}
								<span className='hljs-attr'>city</span>: <span className='hljs-string'>'Depok'</span>,{'\n'}
								{'          '}
								<span className='hljs-attr'>postal_code</span>: <span className='hljs-string'>'16436'</span>
								{'\n'}
								{'        '}
								{'}'}
								{'\n'}
								{'      '}
								{'}'}
								{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-20'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} v4 <span className='hljs-keyword'>as</span> uuidv4 {'}'}{' '}
								<span className='hljs-keyword'>from</span> <span className='hljs-string'>'uuid'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> snap = <span className='hljs-keyword'>new</span> MidtransClient.Snap(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}snap.createTransaction({'{'}
								{'\n'}
								{'      '}
								<span className='hljs-attr'>payment_type</span>: <span className='hljs-string'>'bank_transfer'</span>,{'\n'}
								{'      '}
								<span className='hljs-attr'>bank_transfer</span>: {'{'} <span className='hljs-attr'>bank</span>:{' '}
								<span className='hljs-string'>'bca'</span> {'}'},{'\n'}
								{'      '}
								<span className='hljs-attr'>transaction_details</span>: {'{'}
								{'\n'}
								{'        '}
								<span className='hljs-attr'>order_id</span>: uuidv4(),{'\n'}
								{'        '}
								<span className='hljs-attr'>gross_amount</span>: <span className='hljs-number'>100000</span>
								{'\n'}
								{'      '}
								{'}'},{'\n'}
								{'      '}
								<span className='hljs-attr'>item_details</span>: [{'\n'}
								{'        '}
								{'{'}
								{'\n'}
								{'         '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'         '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'ayam bakar sambal balado'</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>2</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>25000</span>
								{'\n'}
								{'        '}
								{'}'},{'\n'}
								{'        '}
								{'{'}
								{'\n'}
								{'         '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'         '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'sop iga bakar daging lunak'</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>1</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>30000</span>
								{'\n'}
								{'        '}
								{'}'},{'\n'}
								{'        '}
								{'{'}
								{'\n'}
								{'         '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'         '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'just alpuckat'</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>2</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>20000</span>
								{'\n'}
								{'        '}
								{'}'}
								{'\n'}
								{'      '}],{'\n'}
								{'      '}
								<span className='hljs-attr'>customer_details</span>: {'{'}
								{'\n'}
								{'      '}
								{'\t'}
								<span className='hljs-attr'>first_name</span>: <span className='hljs-string'>'restu wahyu'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>last_name</span>: <span className='hljs-string'>' saputra'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>email</span>: <span className='hljs-string'>'restuwahyu13@zetmail.com'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>phone</span>: <span className='hljs-string'>'087820154350'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>billing_address</span>:{'  '}
								{'{'}
								{'\n'}
								{'          '}
								<span className='hljs-attr'>address</span>: <span className='hljs-string'>'jl.sibuta gua hantu no.120'</span>,
								{'\n'}
								{'          '}
								<span className='hljs-attr'>city</span>: <span className='hljs-string'>'Depok'</span>,{'\n'}
								{'          '}
								<span className='hljs-attr'>postal_code</span>: <span className='hljs-string'>'16436'</span>
								{'\n'}
								{'        '}
								{'}'}
								{'\n'}
								{'      '}
								{'}'}
								{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
				<li>
					<h4 id='createtransactiontoken-parameter-object--promise'>createTransactionToken( parameter: object ): Promise</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>createTransactionToken</td>
								<td>
									<em>POST</em>
								</td>
								<td>create transaction payment token using snap integaration payment method</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-21'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} <span className='hljs-attr'>v4</span>: uuidv4 {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'uuid'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> snap = <span className='hljs-keyword'>new</span> MidtransClient.Snap(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}snap.createTransactionToken({'{'}
								{'\n'}
								{'      '}
								<span className='hljs-attr'>payment_type</span>: <span className='hljs-string'>'bank_transfer'</span>,{'\n'}
								{'      '}
								<span className='hljs-attr'>bank_transfer</span>: {'{'} <span className='hljs-attr'>bank</span>:{' '}
								<span className='hljs-string'>'bca'</span> {'}'},{'\n'}
								{'      '}
								<span className='hljs-attr'>transaction_details</span>: {'{'}
								{'\n'}
								{'        '}
								<span className='hljs-attr'>order_id</span>: uuidv4(),{'\n'}
								{'        '}
								<span className='hljs-attr'>gross_amount</span>: <span className='hljs-number'>100000</span>
								{'\n'}
								{'      '}
								{'}'},{'\n'}
								{'      '}
								<span className='hljs-attr'>item_details</span>: [{'\n'}
								{'        '}
								{'{'}
								{'\n'}
								{'         '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'         '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'ayam bakar sambal balado'</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>2</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>25000</span>
								{'\n'}
								{'        '}
								{'}'},{'\n'}
								{'        '}
								{'{'}
								{'\n'}
								{'         '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'         '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'sop iga bakar daging lunak'</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>1</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>30000</span>
								{'\n'}
								{'        '}
								{'}'},{'\n'}
								{'        '}
								{'{'}
								{'\n'}
								{'         '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'         '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'just alpuckat'</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>2</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>10000</span>
								{'\n'}
								{'        '}
								{'}'}
								{'\n'}
								{'      '}],{'\n'}
								{'      '}
								<span className='hljs-attr'>customer_details</span>: {'{'}
								{'\n'}
								{'        '}
								<span className='hljs-attr'>first_name</span>: <span className='hljs-string'>'restu wahyu'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>last_name</span>: <span className='hljs-string'>' saputra'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>email</span>: <span className='hljs-string'>'restuwahyu13@zetmail.com'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>phone</span>: <span className='hljs-string'>'087820154350'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>billing_address</span>:{'  '}
								{'{'}
								{'\n'}
								{'          '}
								<span className='hljs-attr'>address</span>: <span className='hljs-string'>'jl.sibuta gua hantu no.120'</span>,
								{'\n'}
								{'          '}
								<span className='hljs-attr'>city</span>: <span className='hljs-string'>'Depok'</span>,{'\n'}
								{'          '}
								<span className='hljs-attr'>postal_code</span>: <span className='hljs-string'>'16436'</span>
								{'\n'}
								{'        '}
								{'}'}
								{'\n'}
								{'      '}
								{'}'}
								{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-21'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} v4 <span className='hljs-keyword'>as</span> uuidv4 {'}'}{' '}
								<span className='hljs-keyword'>from</span> <span className='hljs-string'>'uuid'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> snap = <span className='hljs-keyword'>new</span> MidtransClient.Snap(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}snap.createTransactionToken({'{'}
								{'\n'}
								{'      '}
								<span className='hljs-attr'>payment_type</span>: <span className='hljs-string'>'bank_transfer'</span>,{'\n'}
								{'      '}
								<span className='hljs-attr'>bank_transfer</span>: {'{'} <span className='hljs-attr'>bank</span>:{' '}
								<span className='hljs-string'>'bca'</span> {'}'},{'\n'}
								{'      '}
								<span className='hljs-attr'>transaction_details</span>: {'{'}
								{'\n'}
								{'        '}
								<span className='hljs-attr'>order_id</span>: uuidv4(),{'\n'}
								{'        '}
								<span className='hljs-attr'>gross_amount</span>: <span className='hljs-number'>100000</span>
								{'\n'}
								{'      '}
								{'}'},{'\n'}
								{'      '}
								<span className='hljs-attr'>item_details</span>: [{'\n'}
								{'        '}
								{'{'}
								{'\n'}
								{'         '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'         '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'ayam bakar sambal balado'</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>2</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>25000</span>
								{'\n'}
								{'        '}
								{'}'},{'\n'}
								{'        '}
								{'{'}
								{'\n'}
								{'         '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'         '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'sop iga bakar daging lunak'</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>1</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>30000</span>
								{'\n'}
								{'        '}
								{'}'},{'\n'}
								{'        '}
								{'{'}
								{'\n'}
								{'         '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'         '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'just alpuckat'</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>2</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>20000</span>
								{'\n'}
								{'        '}
								{'}'}
								{'\n'}
								{'      '}],{'\n'}
								{'      '}
								<span className='hljs-attr'>customer_details</span>: {'{'}
								{'\n'}
								{'      '}
								{'\t'}
								<span className='hljs-attr'>first_name</span>: <span className='hljs-string'>'restu wahyu'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>last_name</span>: <span className='hljs-string'>' saputra'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>email</span>: <span className='hljs-string'>'restuwahyu13@zetmail.com'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>phone</span>: <span className='hljs-string'>'087820154350'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>billing_address</span>:{'  '}
								{'{'}
								{'\n'}
								{'          '}
								<span className='hljs-attr'>address</span>: <span className='hljs-string'>'jl.sibuta gua hantu no.120'</span>,
								{'\n'}
								{'          '}
								<span className='hljs-attr'>city</span>: <span className='hljs-string'>'Depok'</span>,{'\n'}
								{'          '}
								<span className='hljs-attr'>postal_code</span>: <span className='hljs-string'>'16436'</span>
								{'\n'}
								{'        '}
								{'}'}
								{'\n'}
								{'      '}
								{'}'}
								{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
				<li>
					<h4 id='createtransactionredirecturl-parameter-object--promise'>
						createTransactionRedirectUrl( parameter: object ): Promise
					</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>createTransactionRedirectUrl</td>
								<td>
									<em>POST</em>
								</td>
								<td>create transaction payment redirect using snap integaration payment method</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-22'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} <span className='hljs-attr'>v4</span>: uuidv4 {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'uuid'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> snap = <span className='hljs-keyword'>new</span> MidtransClient.Snap(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}snap.createTransactionRedirectUrl({'{'}
								{'\n'}
								{'      '}
								<span className='hljs-attr'>payment_type</span>: <span className='hljs-string'>'bank_transfer'</span>,{'\n'}
								{'      '}
								<span className='hljs-attr'>bank_transfer</span>: {'{'} <span className='hljs-attr'>bank</span>:{' '}
								<span className='hljs-string'>'bca'</span> {'}'},{'\n'}
								{'      '}
								<span className='hljs-attr'>transaction_details</span>: {'{'}
								{'\n'}
								{'        '}
								<span className='hljs-attr'>order_id</span>: uuidv4(),{'\n'}
								{'        '}
								<span className='hljs-attr'>gross_amount</span>: <span className='hljs-number'>100000</span>
								{'\n'}
								{'      '}
								{'}'},{'\n'}
								{'      '}
								<span className='hljs-attr'>item_details</span>: [{'\n'}
								{'        '}
								{'{'}
								{'\n'}
								{'         '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'         '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'ayam bakar sambal balado'</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>2</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>25000</span>
								{'\n'}
								{'        '}
								{'}'},{'\n'}
								{'        '}
								{'{'}
								{'\n'}
								{'         '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'         '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'sop iga bakar daging lunak'</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>1</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>30000</span>
								{'\n'}
								{'        '}
								{'}'},{'\n'}
								{'        '}
								{'{'}
								{'\n'}
								{'         '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'         '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'just alpuckat'</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>2</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>10000</span>
								{'\n'}
								{'        '}
								{'}'}
								{'\n'}
								{'      '}],{'\n'}
								{'      '}
								<span className='hljs-attr'>customer_details</span>: {'{'}
								{'\n'}
								{'      '}
								{'\t'}
								<span className='hljs-attr'>first_name</span>: <span className='hljs-string'>'restu wahyu'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>last_name</span>: <span className='hljs-string'>' saputra'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>email</span>: <span className='hljs-string'>'restuwahyu13@zetmail.com'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>phone</span>: <span className='hljs-string'>'087820154350'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>billing_address</span>:{'  '}
								{'{'}
								{'\n'}
								{'          '}
								<span className='hljs-attr'>address</span>: <span className='hljs-string'>'jl.sibuta gua hantu no.120'</span>,
								{'\n'}
								{'          '}
								<span className='hljs-attr'>city</span>: <span className='hljs-string'>'Depok'</span>,{'\n'}
								{'          '}
								<span className='hljs-attr'>postal_code</span>: <span className='hljs-string'>'16436'</span>
								{'\n'}
								{'        '}
								{'}'}
								{'\n'}
								{'      '}
								{'}'}
								{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-22'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} v4 <span className='hljs-keyword'>as</span> uuidv4 {'}'}{' '}
								<span className='hljs-keyword'>from</span> <span className='hljs-string'>'uuid'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> snap = <span className='hljs-keyword'>new</span> MidtransClient.Snap(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}snap.createTransactionRedirectUrl({'{'}
								{'\n'}
								{'      '}
								<span className='hljs-attr'>payment_type</span>: <span className='hljs-string'>'bank_transfer'</span>,{'\n'}
								{'      '}
								<span className='hljs-attr'>bank_transfer</span>: {'{'} <span className='hljs-attr'>bank</span>:{' '}
								<span className='hljs-string'>'bca'</span> {'}'},{'\n'}
								{'      '}
								<span className='hljs-attr'>transaction_details</span>: {'{'}
								{'\n'}
								{'        '}
								<span className='hljs-attr'>order_id</span>: uuidv4(),{'\n'}
								{'        '}
								<span className='hljs-attr'>gross_amount</span>: <span className='hljs-number'>100000</span>
								{'\n'}
								{'      '}
								{'}'},{'\n'}
								{'      '}
								<span className='hljs-attr'>item_details</span>: [{'\n'}
								{'        '}
								{'{'}
								{'\n'}
								{'         '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'         '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'ayam bakar sambal balado'</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>2</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>25000</span>
								{'\n'}
								{'        '}
								{'}'},{'\n'}
								{'        '}
								{'{'}
								{'\n'}
								{'         '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'         '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'sop iga bakar daging lunak'</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>1</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>30000</span>
								{'\n'}
								{'        '}
								{'}'},{'\n'}
								{'        '}
								{'{'}
								{'\n'}
								{'         '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'         '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'just alpuckat'</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>2</span>
								{'\n'}
								{'         '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>20000</span>
								{'\n'}
								{'        '}
								{'}'}
								{'\n'}
								{'      '}],{'\n'}
								{'      '}
								<span className='hljs-attr'>customer_details</span>: {'{'}
								{'\n'}
								{'        '}
								<span className='hljs-attr'>first_name</span>: <span className='hljs-string'>'restu wahyu'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>last_name</span>: <span className='hljs-string'>' saputra'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>email</span>: <span className='hljs-string'>'restuwahyu13@zetmail.com'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>phone</span>: <span className='hljs-string'>'087820154350'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>billing_address</span>:{'  '}
								{'{'}
								{'\n'}
								{'          '}
								<span className='hljs-attr'>address</span>: <span className='hljs-string'>'jl.sibuta gua hantu no.120'</span>,
								{'\n'}
								{'          '}
								<span className='hljs-attr'>city</span>: <span className='hljs-string'>'Depok'</span>,{'\n'}
								{'          '}
								<span className='hljs-attr'>postal_code</span>: <span className='hljs-string'>'16436'</span>
								{'\n'}
								{'        '}
								{'}'}
								{'\n'}
								{'      '}
								{'}'}
								{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
			</ul>
			<h3 id='transaction-api-services'>Transaction API Services</h3>
			<ul>
				<li>
					<h4 id='status-transactionid-string--promise'>status( transactionId: string ): Promise</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>status</td>
								<td>
									<em>GET</em>
								</td>
								<td>Get information status of a transaction with certain order_id or transaction_id</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-23'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} <span className='hljs-attr'>v4</span>: uuidv4 {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'uuid'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> snap = <span className='hljs-keyword'>new</span> MidtransClient.Snap(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}snap.transaction.status(<span className='hljs-string'>'be4f3e44-d6ee-4355-8c64-c1d1dc7f4590'</span>){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-23'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} v4 <span className='hljs-keyword'>as</span> uuidv4 {'}'}{' '}
								<span className='hljs-keyword'>from</span> <span className='hljs-string'>'uuid'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> snap = <span className='hljs-keyword'>new</span> MidtransClient.Snap(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}snap.transaction.status(<span className='hljs-string'>'be4f3e44-d6ee-4355-8c64-c1d1dc7f4590'</span>){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
				<li>
					<h4 id='statusb2b-transactionid-string--promise'>statusb2b( transactionId: string ): Promise</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>statusb2b</td>
								<td>
									<em>GET</em>
								</td>
								<td>Get information status of multiple B2B transactions related to certain order_id or transaction_id</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-24'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} <span className='hljs-attr'>v4</span>: uuidv4 {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'uuid'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> snap = <span className='hljs-keyword'>new</span> MidtransClient.Snap(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}snap.transaction.status(<span className='hljs-string'>'be4f3e44-d6ee-4355-8c64-c1d1dc7f4590'</span>){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-24'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} v4 <span className='hljs-keyword'>as</span> uuidv4 {'}'}{' '}
								<span className='hljs-keyword'>from</span> <span className='hljs-string'>'uuid'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> snap = <span className='hljs-keyword'>new</span> MidtransClient.Snap(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}snap.transaction.statusb2b(<span className='hljs-string'>'be4f3e44-d6ee-4355-8c64-c1d1dc7f4590'</span>)
								{'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
				<li>
					<h4 id='approve-transactionid-string--promise'>approve( transactionId: string ): Promise</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>approve</td>
								<td>
									<em>POST</em>
								</td>
								<td>
									Approve a transaction with certain order_id or transaction_id which gets challenge status from Fraud Detection
									System
								</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-25'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} <span className='hljs-attr'>v4</span>: uuidv4 {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'uuid'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> snap = <span className='hljs-keyword'>new</span> MidtransClient.Snap(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}snap.transaction.approve(<span className='hljs-string'>'be4f3e44-d6ee-4355-8c64-c1d1dc7f4590'</span>){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-25'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} v4 <span className='hljs-keyword'>as</span> uuidv4 {'}'}{' '}
								<span className='hljs-keyword'>from</span> <span className='hljs-string'>'uuid'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> snap = <span className='hljs-keyword'>new</span> MidtransClient.Snap(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}snap.transaction.approve(<span className='hljs-string'>'be4f3e44-d6ee-4355-8c64-c1d1dc7f4590'</span>){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
				<li>
					<h4 id='deny-transactionid-string--promise'>deny( transactionId: string ): Promise</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>deny</td>
								<td>
									<em>POST</em>
								</td>
								<td>
									Deny a transaction with certain order_id or transaction_id which gets challenge status from Fraud Detection
									System
								</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-26'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} <span className='hljs-attr'>v4</span>: uuidv4 {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'uuid'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> snap = <span className='hljs-keyword'>new</span> MidtransClient.Snap(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}snap.transaction.deny(<span className='hljs-string'>'be4f3e44-d6ee-4355-8c64-c1d1dc7f4590'</span>){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-26'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} v4 <span className='hljs-keyword'>as</span> uuidv4 {'}'}{' '}
								<span className='hljs-keyword'>from</span> <span className='hljs-string'>'uuid'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> snap = <span className='hljs-keyword'>new</span> MidtransClient.Snap(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}snap.transaction.deny(<span className='hljs-string'>'be4f3e44-d6ee-4355-8c64-c1d1dc7f4590'</span>){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
				<li>
					<h4 id='cancel-transactionid-string--promise'>cancel( transactionId: string ): Promise</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>cancel</td>
								<td>
									<em>POST</em>
								</td>
								<td>Cancel a transaction with certain order_id or transaction_id before settlement process</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-27'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} <span className='hljs-attr'>v4</span>: uuidv4 {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'uuid'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> snap = <span className='hljs-keyword'>new</span> MidtransClient.Snap(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}snap.transaction.cancel(<span className='hljs-string'>'be4f3e44-d6ee-4355-8c64-c1d1dc7f4590'</span>){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-27'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} v4 <span className='hljs-keyword'>as</span> uuidv4 {'}'}{' '}
								<span className='hljs-keyword'>from</span> <span className='hljs-string'>'uuid'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> snap = <span className='hljs-keyword'>new</span> MidtransClient.Snap(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}snap.transaction.cancel(<span className='hljs-string'>'be4f3e44-d6ee-4355-8c64-c1d1dc7f4590'</span>){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
				<li>
					<h4 id='expire-transactionid-string--promise'>expire( transactionId: string ): Promise</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>expire</td>
								<td>
									<em>POST</em>
								</td>
								<td>Update order_id or transaction_id with pending status to be expired</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-28'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} <span className='hljs-attr'>v4</span>: uuidv4 {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'uuid'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> snap = <span className='hljs-keyword'>new</span> MidtransClient.Snap(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}snap.transaction.expire(<span className='hljs-string'>'be4f3e44-d6ee-4355-8c64-c1d1dc7f4590'</span>){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-28'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} v4 <span className='hljs-keyword'>as</span> uuidv4 {'}'}{' '}
								<span className='hljs-keyword'>from</span> <span className='hljs-string'>'uuid'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> snap = <span className='hljs-keyword'>new</span> MidtransClient.Snap(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}snap.transaction.expire(<span className='hljs-string'>'be4f3e44-d6ee-4355-8c64-c1d1dc7f4590'</span>){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
				<li>
					<h4 id='refund-transactionid-string-parameter-object-promise'>
						refund( transactionId: string, parameter?: object): Promise
					</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>refund</td>
								<td>
									<em>POST</em>
								</td>
								<td>Update order_id or transaction_id with settlement status to be refund</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-29'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} <span className='hljs-attr'>v4</span>: uuidv4 {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'uuid'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> snap = <span className='hljs-keyword'>new</span> MidtransClient.Snap(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}snap.transaction.refund(<span className='hljs-string'>'be4f3e44-d6ee-4355-8c64-c1d1dc7f4590'</span>, {'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>amount</span>: <span className='hljs-number'>1000000</span>,{'\n'}
								{'     '}
								<span className='hljs-attr'>reason</span>: <span className='hljs-string'>'Reason to refund payouts'</span>
								{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-29'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} v4 <span className='hljs-keyword'>as</span> uuidv4 {'}'}{' '}
								<span className='hljs-keyword'>from</span> <span className='hljs-string'>'uuid'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> snap = <span className='hljs-keyword'>new</span> MidtransClient.Snap(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}snap.transaction.refund(<span className='hljs-string'>'be4f3e44-d6ee-4355-8c64-c1d1dc7f4590'</span>, {'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>amount</span>: <span className='hljs-number'>1000000</span>,{'\n'}
								{'     '}
								<span className='hljs-attr'>reason</span>: <span className='hljs-string'>'Reason to refund payouts'</span>
								{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
				<li>
					<h4 id='refunddirect-transactionid-string-parameter-object-promise'>
						refundDirect( transactionId: string, parameter?: object): Promise
					</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>refundDirect</td>
								<td>
									<em>POST</em>
								</td>
								<td>
									Attempt to send refund to bank or payment provider and update the transaction status to refund if it succeeded
								</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-30'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} <span className='hljs-attr'>v4</span>: uuidv4 {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'uuid'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> snap = <span className='hljs-keyword'>new</span> MidtransClient.Snap(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}snap.transaction.refundDirect(<span className='hljs-string'>'be4f3e44-d6ee-4355-8c64-c1d1dc7f4590'</span>,{' '}
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>amount</span>: <span className='hljs-number'>1000000</span>,{'\n'}
								{'     '}
								<span className='hljs-attr'>reason</span>: <span className='hljs-string'>'Reason to refund direct payouts'</span>
								{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-30'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} v4 <span className='hljs-keyword'>as</span> uuidv4 {'}'}{' '}
								<span className='hljs-keyword'>from</span> <span className='hljs-string'>'uuid'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> snap = <span className='hljs-keyword'>new</span> MidtransClient.Snap(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}snap.transaction.refundDirect(<span className='hljs-string'>'be4f3e44-d6ee-4355-8c64-c1d1dc7f4590'</span>,{' '}
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>amount</span>: <span className='hljs-number'>1000000</span>,{'\n'}
								{'     '}
								<span className='hljs-attr'>reason</span>: <span className='hljs-string'>'Reason to direct payouts'</span>
								{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
				<li>
					<h4 id='notification-notification-object--promise'>notification( notification: object ): Promise</h4>
					<table>
						<thead>
							<tr>
								<th>Method</th>
								<th>Request</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>notification</td>
								<td>
									<em>undefined</em>
								</td>
								<td>additional mechanism we provide to verify the content and the origin of the notification is to challenge</td>
							</tr>
						</tbody>
					</table>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-31'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} <span className='hljs-attr'>v4</span>: uuidv4 {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'uuid'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>let</span> getResponse;{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> snap = <span className='hljs-keyword'>new</span> MidtransClient.Snap(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'    '}snap.transaction.status(<span className='hljs-string'>'be4f3e44-d6ee-4355-8c64-c1d1dc7f4590'</span>){'\n'}
								{'   '}.then(
								<span className='hljs-function'>
									(<span className='hljs-params'>res</span>) =&gt;
								</span>{' '}
								getResponse = res){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
								{'\n'}
								{'   '}snap.transaction.notification(<span className='hljs-built_in'>JSON</span>.stringify(getResponse)){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-31'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} v4 <span className='hljs-keyword'>as</span> uuidv4 {'}'}{' '}
								<span className='hljs-keyword'>from</span> <span className='hljs-string'>'uuid'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>let</span> getResponse;{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> snap = <span className='hljs-keyword'>new</span> MidtransClient.Snap(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}snap.transaction.status(<span className='hljs-string'>'be4f3e44-d6ee-4355-8c64-c1d1dc7f4590'</span>){'\n'}
								{'   '}.then(
								<span className='hljs-function'>
									(<span className='hljs-params'>res</span>) =&gt;
								</span>{' '}
								getResponse = res){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
								{'\n'}
								{'   '}snap.transaction.notification(<span className='hljs-built_in'>JSON</span>.stringify(getResponse)){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
			</ul>
			<h2 id='custome-usage'><b>Custome Usage</b></h2>
			<p>
				For custom usage already using type definitions for ease of use and for all functions that use parameters all have type
				definitions.
			</p>
			<ul>
				<li>
					<h4 id='charge-parameter-object---promise-1'>charge( parameter: object ) : Promise</h4>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-32'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} <span className='hljs-attr'>v4</span>: uuidv4 {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'uuid'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> core = <span className='hljs-keyword'>new</span>{' '}
								MidtransClient.CoreApi({'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}core.charge({'{'}
								{'\n'}
								{'      '}
								<span className='hljs-attr'>chargeBankTransfer</span>: {'{'}
								{'\n'}
								{'        '}
								<span className='hljs-attr'>payment_type</span>: <span className='hljs-string'>'bank_transfer'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>bank_transfer</span>: {'{'} <span className='hljs-attr'>bank</span>:{' '}
								<span className='hljs-string'>'bca'</span> {'}'},{'\n'}
								{'        '}
								<span className='hljs-attr'>transaction_details</span>: {'{'}
								{'\n'}
								{'          '}
								<span className='hljs-attr'>order_id</span>: uuidv4(),{'\n'}
								{'          '}
								<span className='hljs-attr'>gross_amount</span>: <span className='hljs-number'>100000</span>
								{'\n'}
								{'        '}
								{'}'},{'\n'}
								{'        '}
								<span className='hljs-attr'>item_details</span>: [{'\n'}
								{'          '}
								{'{'}
								{'\n'}
								{'           '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'           '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'ayam bakar sambal balado'</span>
								{'\n'}
								{'           '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>2</span>
								{'\n'}
								{'           '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>25000</span>
								{'\n'}
								{'          '}
								{'}'},{'\n'}
								{'          '}
								{'{'}
								{'\n'}
								{'           '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'           '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'sop iga bakar daging lunak'</span>
								{'\n'}
								{'           '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>1</span>
								{'\n'}
								{'           '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>30000</span>
								{'\n'}
								{'          '}
								{'}'},{'\n'}
								{'          '}
								{'{'}
								{'\n'}
								{'           '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'           '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'just alpuckat'</span>
								{'\n'}
								{'           '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>2</span>
								{'\n'}
								{'           '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>10000</span>
								{'\n'}
								{'          '}
								{'}'}
								{'\n'}
								{'        '}],{'\n'}
								{'        '}
								<span className='hljs-attr'>customer_details</span>: {'{'}
								{'\n'}
								{'          '}
								<span className='hljs-attr'>first_name</span>: <span className='hljs-string'>'restu wahyu'</span>,{'\n'}
								{'          '}
								<span className='hljs-attr'>last_name</span>: <span className='hljs-string'>' saputra'</span>,{'\n'}
								{'          '}
								<span className='hljs-attr'>email</span>: <span className='hljs-string'>'restuwahyu13@zetmail.com'</span>,{'\n'}
								{'          '}
								<span className='hljs-attr'>phone</span>: <span className='hljs-string'>'087820154350'</span>,{'\n'}
								{'          '}
								<span className='hljs-attr'>billing_address</span>:{'  '}
								{'{'}
								{'\n'}
								{'            '}
								<span className='hljs-attr'>address</span>: <span className='hljs-string'>'jl.sibuta gua hantu no.120'</span>,
								{'\n'}
								{'            '}
								<span className='hljs-attr'>city</span>: <span className='hljs-string'>'Depok'</span>,{'\n'}
								{'            '}
								<span className='hljs-attr'>postal_code</span>: <span className='hljs-string'>'16436'</span>
								{'\n'}
								{'          '}
								{'}'}
								{'\n'}
								{'        '}
								{'}'}
								{'\n'}
								{'     '}
								{'}'}
								{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-32'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} v4 <span className='hljs-keyword'>as</span> uuidv4 {'}'}{' '}
								<span className='hljs-keyword'>from</span> <span className='hljs-string'>'uuid'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> core = <span className='hljs-keyword'>new</span>{' '}
								MidtransClient.CoreApi({'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}core.charge({'{'}
								{'\n'}
								{'      '}
								<span className='hljs-attr'>chargeBankTransfer</span>: {'{'}
								{'\n'}
								{'        '}
								<span className='hljs-attr'>payment_type</span>: <span className='hljs-string'>'bank_transfer'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>bank_transfer</span>: {'{'} <span className='hljs-attr'>bank</span>:{' '}
								<span className='hljs-string'>'bca'</span> {'}'},{'\n'}
								{'        '}
								<span className='hljs-attr'>transaction_details</span>: {'{'}
								{'\n'}
								{'          '}
								<span className='hljs-attr'>order_id</span>: uuidv4(),{'\n'}
								{'          '}
								<span className='hljs-attr'>gross_amount</span>: <span className='hljs-number'>100000</span>
								{'\n'}
								{'        '}
								{'}'},{'\n'}
								{'        '}
								<span className='hljs-attr'>item_details</span>: [{'\n'}
								{'          '}
								{'{'}
								{'\n'}
								{'           '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'           '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'ayam bakar sambal balado'</span>
								{'\n'}
								{'           '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>2</span>
								{'\n'}
								{'           '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>25000</span>
								{'\n'}
								{'          '}
								{'}'},{'\n'}
								{'          '}
								{'{'}
								{'\n'}
								{'           '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'           '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'sop iga bakar daging lunak'</span>
								{'\n'}
								{'           '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>1</span>
								{'\n'}
								{'           '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>30000</span>
								{'\n'}
								{'          '}
								{'}'},{'\n'}
								{'          '}
								{'{'}
								{'\n'}
								{'           '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'           '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'just alpuckat'</span>
								{'\n'}
								{'           '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>2</span>
								{'\n'}
								{'           '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>10000</span>
								{'\n'}
								{'          '}
								{'}'}
								{'\n'}
								{'        '}],{'\n'}
								{'        '}
								<span className='hljs-attr'>customer_details</span>: {'{'}
								{'\n'}
								{'          '}
								<span className='hljs-attr'>first_name</span>: <span className='hljs-string'>'restu wahyu'</span>,{'\n'}
								{'          '}
								<span className='hljs-attr'>last_name</span>: <span className='hljs-string'>' saputra'</span>,{'\n'}
								{'          '}
								<span className='hljs-attr'>email</span>: <span className='hljs-string'>'restuwahyu13@zetmail.com'</span>,{'\n'}
								{'          '}
								<span className='hljs-attr'>phone</span>: <span className='hljs-string'>'087820154350'</span>,{'\n'}
								{'          '}
								<span className='hljs-attr'>billing_address</span>:{'  '}
								{'{'}
								{'\n'}
								{'            '}
								<span className='hljs-attr'>address</span>: <span className='hljs-string'>'jl.sibuta gua hantu no.120'</span>,
								{'\n'}
								{'            '}
								<span className='hljs-attr'>city</span>: <span className='hljs-string'>'Depok'</span>,{'\n'}
								{'            '}
								<span className='hljs-attr'>postal_code</span>: <span className='hljs-string'>'16436'</span>
								{'\n'}
								{'          '}
								{'}'}
								{'\n'}
								{'        '}
								{'}'}
								{'\n'}
								{'     '}
								{'}'}
								{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
				<li>
					<h4 id='createtransaction-parameter-object--promise-1'>createTransaction( parameter: object ): Promise</h4>
					<ul>
						<li>
							<h5 id='example-usage-using-commonjs-33'>Example Usage Using CommonJS</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} MidtransClient {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'midtrans-node-client'</span>){'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> {'{'} <span className='hljs-attr'>v4</span>: uuidv4 {'}'} ={' '}
								<span className='hljs-built_in'>require</span>(<span className='hljs-string'>'uuid'</span>){'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> snap = <span className='hljs-keyword'>new</span> MidtransClient.Snap(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}snap.createTransaction({'{'}
								{'\n'}
								{'      '}
								<span className='hljs-attr'>BcaVirtualAccount</span>: {'{'}
								{'\n'}
								{'        '}
								<span className='hljs-attr'>payment_type</span>: <span className='hljs-string'>'bank_transfer'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>bank_transfer</span>: {'{'} <span className='hljs-attr'>bank</span>:{' '}
								<span className='hljs-string'>'bca'</span> {'}'},{'\n'}
								{'        '}
								<span className='hljs-attr'>transaction_details</span>: {'{'}
								{'\n'}
								{'          '}
								<span className='hljs-attr'>order_id</span>: uuidv4(),{'\n'}
								{'          '}
								<span className='hljs-attr'>gross_amount</span>: <span className='hljs-number'>100000</span>
								{'\n'}
								{'        '}
								{'}'},{'\n'}
								{'        '}
								<span className='hljs-attr'>item_details</span>: [{'\n'}
								{'          '}
								{'{'}
								{'\n'}
								{'           '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'           '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'ayam bakar sambal balado'</span>
								{'\n'}
								{'           '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>2</span>
								{'\n'}
								{'           '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>25000</span>
								{'\n'}
								{'          '}
								{'}'},{'\n'}
								{'          '}
								{'{'}
								{'\n'}
								{'           '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'           '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'sop iga bakar daging lunak'</span>
								{'\n'}
								{'           '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>1</span>
								{'\n'}
								{'           '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>30000</span>
								{'\n'}
								{'          '}
								{'}'},{'\n'}
								{'          '}
								{'{'}
								{'\n'}
								{'           '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'           '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'just alpuckat'</span>
								{'\n'}
								{'           '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>2</span>
								{'\n'}
								{'           '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>20000</span>
								{'\n'}
								{'          '}
								{'}'}
								{'\n'}
								{'        '}],{'\n'}
								{'        '}
								<span className='hljs-attr'>customer_details</span>: {'{'}
								{'\n'}
								{'          '}
								<span className='hljs-attr'>first_name</span>: <span className='hljs-string'>'restu wahyu'</span>,{'\n'}
								{'          '}
								<span className='hljs-attr'>last_name</span>: <span className='hljs-string'>' saputra'</span>,{'\n'}
								{'          '}
								<span className='hljs-attr'>email</span>: <span className='hljs-string'>'restuwahyu13@zetmail.com'</span>,{'\n'}
								{'          '}
								<span className='hljs-attr'>phone</span>: <span className='hljs-string'>'087820154350'</span>,{'\n'}
								{'          '}
								<span className='hljs-attr'>billing_address</span>:{'  '}
								{'{'}
								{'\n'}
								{'            '}
								<span className='hljs-attr'>address</span>: <span className='hljs-string'>'jl.sibuta gua hantu no.120'</span>,
								{'\n'}
								{'            '}
								<span className='hljs-attr'>city</span>: <span className='hljs-string'>'Depok'</span>,{'\n'}
								{'            '}
								<span className='hljs-attr'>postal_code</span>: <span className='hljs-string'>'16436'</span>
								{'\n'}
								{'          '}
								{'}'}
								{'\n'}
								{'        '}
								{'}'}
								{'\n'}
								{'     '}
								{'}'}
								{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
					<ul>
						<li>
							<h5 id='example-usage-using-es6-33'>Example Usage Using ES6</h5>
						</li>
					</ul>
					<pre>
						<code className='language-javascript'>
							<div>
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} MidtransClient {'}'} <span className='hljs-keyword'>from</span>{' '}
								<span className='hljs-string'>'midtrans-node-client'</span>
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>import</span> {'{'} v4 <span className='hljs-keyword'>as</span> uuidv4 {'}'}{' '}
								<span className='hljs-keyword'>from</span> <span className='hljs-string'>'uuid'</span>
								{'\n'}
								{'\n'}
								{'   '}
								<span className='hljs-keyword'>const</span> snap = <span className='hljs-keyword'>new</span> MidtransClient.Snap(
								{'{'}
								{'\n'}
								{'     '}
								<span className='hljs-attr'>isProduction</span>: process.env.DEVELOPMENT,{'\n'}
								{'     '}
								<span className='hljs-attr'>serverKey</span>: process.env.SERVER_KEY,{'\n'}
								{'     '}
								<span className='hljs-attr'>clientKey</span>: process.env.CLIENT_KEY{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'\n'}
								{'   '}snap.createTransaction({'{'}
								{'\n'}
								{'      '}
								<span className='hljs-attr'>BcaVirtualAccount</span>: {'{'}
								{'\n'}
								{'        '}
								<span className='hljs-attr'>payment_type</span>: <span className='hljs-string'>'bank_transfer'</span>,{'\n'}
								{'        '}
								<span className='hljs-attr'>bank_transfer</span>: {'{'} <span className='hljs-attr'>bank</span>:{' '}
								<span className='hljs-string'>'bca'</span> {'}'},{'\n'}
								{'        '}
								<span className='hljs-attr'>transaction_details</span>: {'{'}
								{'\n'}
								{'          '}
								<span className='hljs-attr'>order_id</span>: uuidv4(),{'\n'}
								{'          '}
								<span className='hljs-attr'>gross_amount</span>: <span className='hljs-number'>100000</span>
								{'\n'}
								{'        '}
								{'}'},{'\n'}
								{'        '}
								<span className='hljs-attr'>item_details</span>: [{'\n'}
								{'          '}
								{'{'}
								{'\n'}
								{'           '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'           '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'ayam bakar sambal balado'</span>
								{'\n'}
								{'           '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>2</span>
								{'\n'}
								{'           '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>25000</span>
								{'\n'}
								{'          '}
								{'}'},{'\n'}
								{'          '}
								{'{'}
								{'\n'}
								{'           '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'           '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'sop iga bakar daging lunak'</span>
								{'\n'}
								{'           '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>1</span>
								{'\n'}
								{'           '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>30000</span>
								{'\n'}
								{'          '}
								{'}'},{'\n'}
								{'          '}
								{'{'}
								{'\n'}
								{'           '}
								<span className='hljs-attr'>id</span>: uuidv4(),{'\n'}
								{'           '}
								<span className='hljs-attr'>name</span>: <span className='hljs-string'>'just alpuckat'</span>
								{'\n'}
								{'           '}
								<span className='hljs-attr'>quantity</span>: <span className='hljs-number'>2</span>
								{'\n'}
								{'           '}
								<span className='hljs-attr'>price</span>: <span className='hljs-number'>20000</span>
								{'\n'}
								{'          '}
								{'}'}
								{'\n'}
								{'        '}],{'\n'}
								{'        '}
								<span className='hljs-attr'>customer_details</span>: {'{'}
								{'\n'}
								{'          '}
								<span className='hljs-attr'>first_name</span>: <span className='hljs-string'>'restu wahyu'</span>,{'\n'}
								{'          '}
								<span className='hljs-attr'>last_name</span>: <span className='hljs-string'>' saputra'</span>,{'\n'}
								{'          '}
								<span className='hljs-attr'>email</span>: <span className='hljs-string'>'restuwahyu13@zetmail.com'</span>,{'\n'}
								{'          '}
								<span className='hljs-attr'>phone</span>: <span className='hljs-string'>'087820154350'</span>,{'\n'}
								{'          '}
								<span className='hljs-attr'>billing_address</span>:{'  '}
								{'{'}
								{'\n'}
								{'            '}
								<span className='hljs-attr'>address</span>: <span className='hljs-string'>'jl.sibuta gua hantu no.120'</span>,
								{'\n'}
								{'            '}
								<span className='hljs-attr'>city</span>: <span className='hljs-string'>'Depok'</span>,{'\n'}
								{'            '}
								<span className='hljs-attr'>postal_code</span>: <span className='hljs-string'>'16436'</span>
								{'\n'}
								{'          '}
								{'}'}
								{'\n'}
								{'        '}
								{'}'}
								{'\n'}
								{'     '}
								{'}'}
								{'\n'}
								{'   '}
								{'}'}){'\n'}
								{'   '}.then(<span className='hljs-built_in'>console</span>.log){'\n'}
								{'   '}.catch(<span className='hljs-built_in'>console</span>.error){'\n'}
							</div>
						</code>
					</pre>
				</li>
			</ul>
			<h3 id='custome-reference'>
				<b>Custome Reference</b>
			</h3>
			<ul>
				<li>
					<h4 id='custome-core-api-service---charge-request'>Custome Core API Service - charge Request</h4>
					<pre>
						<code className='language-javascript'>
							<div>
								chargeBankTransfer?: ChargeBankTransfer{'\n'}
								{'  '}chargeCreditCard?: ChargeCreditCard{'\n'}
								{'  '}chargeNon3DS?: ChargeNon3DS{'\n'}
								{'  '}charge3DS?: Charge3DS{'\n'}
								{'  '}chargePermata?: ChargePermataVirtualAccount{'\n'}
								{'  '}chargeBca?: ChargeBcaVirtualAccount{'\n'}
								{'  '}chargeMandiri?: ChargeMandiriVirtualAccount{'\n'}
								{'  '}chargeBni?: ChargeBniVirtualAccount{'\n'}
								{'  '}chargeBri?: ChargeBriVirtualAccount{'\n'}
								{'  '}chargeBcaKlikPay?: ChargeBcaKlikpay{'\n'}
								{'  '}chargeKlikBca?: ChargeKlikBca{'\n'}
								{'  '}chargeBriEpay?: ChargeBriEpay{'\n'}
								{'  '}chargeChimbClick?: ChargeCimbClick{'\n'}
								{'  '}chargeDanamonOnline?: ChargeDanamonOnline{'\n'}
								{'  '}chargeQris?: ChargeQris{'\n'}
								{'  '}chargeGopay?: ChargeGopay{'\n'}
								{'  '}chargeShopeePay?: ChargeShoopePay{'\n'}
								{'  '}chargeIndomaret?: ChargeIndomaret{'\n'}
								{'  '}chargeAlfamart?: ChargeAlfamart{'\n'}
								{'  '}chargeAkuLaku?: ChargeAkuLaku{'\n'}
							</div>
						</code>
					</pre>
				</li>
				<li>
					<h4 id='custome-snap-service---createtransaction-request'>Custome Snap Service - createTransaction Request</h4>
					<pre>
						<code className='language-javascript'>
							<div>
								{'  '}snapCreditCard?: SnapCreditCard{'\n'}
								{'  '}snapFull?: SnapFull{'\n'}
								{'  '}snapBca?: SnapBcaVirtualAccount{'\n'}
								{'  '}snapPermata?: SnapPermataVirtualAccount{'\n'}
								{'  '}snapBni?: SnapBniVirtualAccount{'\n'}
								{'  '}snapBri?: SnapBriVirtualAccount{'\n'}
								{'  '}snapMandiri?: SnapMandiriVirtualAccount{'\n'}
								{'  '}snapGopay?: SnapGopay{'\n'}
								{'  '}snapKlikBca?: SnapKlikBCA{'\n'}
								{'  '}snapBcaKlikPay?: SnapBcaKlikPay{'\n'}
								{'  '}snapCimbKlik?: SnapCimbKlik{'\n'}
								{'  '}snapDanamonOnline?: SnapDanamonOnlineBanking{'\n'}
								{'  '}snapBriEpay?: SnapBriEpay{'\n'}
								{'  '}snapIndomaret?: SnapIndomaret{'\n'}
								{'  '}snapAlfamart?: SnapAlfamart{'\n'}
								{'  '}snapAkuLaku?: SnapAkuLaku{'\n'}
								{'  '}snapShopePay?: SnapShopeePay{'\n'}
							</div>
						</code>
					</pre>
				</li>
			</ul>
			<h2 id='testing'>
				<b>Testing</b>
			</h2>
			<ul>
				<li>
					<p>Testing Via Local</p>
					<pre>
						<code className='language-sh'>
							<div>
								npm <span className='hljs-built_in'>test</span> or make <span className='hljs-built_in'>test</span>
								{'\n'}
							</div>
						</code>
					</pre>
				</li>
				<li>
					<p>Testing Via Local And Build</p>
					<pre>
						<code className='language-sh'>
							<div>make build{'\n'}</div>
						</code>
					</pre>
				</li>
				<li>
					<p>Testing Via Docker</p>
					<pre>
						<code className='language-sh'>
							<div>docker build -t midtrans-node or make dkb tag=midtrans-node{'\n'}</div>
						</code>
					</pre>
				</li>
			</ul>
			<h2 id='bugs'>
				<b> Bugs </b>
			</h2>
			<p>
				For information on bugs related to package libraries, please visit
				<a href='https://github.com/restuwahyu13/midtrans-node/issues'>here</a>
			</p>
			<h2 id='contributing'>
				<b>Contributing</b>
			</h2>
			<p>
				Want to make <strong>Midtrans Node</strong> more perfect ? Let's contribute and follow the
				<a href='https://github.com/restuwahyu13/midtrans-node/blob/main/CONTRIBUTING.html'>contribution guide.</a>
			</p>
			<h2 id='license'>
				<b> License </b>
			</h2>
			<ul>
				<li>
					<a href='https://github.com/restuwahyu13/streambox-collection/blob/main/LICENSE.html'>MIT License</a>
				</li>
			</ul>
			<p align='right' style={{ padding: 5, borderRadius: '100%', fontSize: 15 }}>
				<b>
					<a href='#midtrans-node'>BACK TO TOP</a>
				</b>
			</p>
		</>
	)
}

export default App
